import { SET_REVIEWS } from "../actions/reviews";

const initialState = {
  reviews: [],
};

export const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REVIEWS:
      return { ...state, reviews: action.payload.reviews };
    default:
      return state;
  }
};
